import { Component, OnInit, Input, ElementRef, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "app-pdf-viewer",
    templateUrl: "./pdf-viewer.component.html",
    styleUrls: ['./pdf-viewer.component.scss'],
    standalone: false
})

export class PdfViewerComponent implements OnInit {

    @Input() pdfUrl: string;
    @Input() pdfName: string;
    @Input() pdfExpenseReceiptId: number;
    @Input() showPdfViewerPanel: boolean;
    @Input() showDeleteButton: boolean = false;
    @Input() isOverLayHide: boolean = false;
    @Input() panelWidth: string = "w-80pc";
    
    @Input() claimType: number = 1;
    @Input() isClaimPage: boolean = false;

    constructor() { }

    ngOnInit() {}

    @Output() callbackEvent = new EventEmitter<boolean>();
    @Output() deletePdfEvent = new EventEmitter<number>();


    dismiss() {
        this.showPdfViewerPanel = false;
        this.pdfUrl = "";
        this.pdfName = "";
        this.pdfExpenseReceiptId = 0;
        this.callbackEvent.emit(false);
    }

    delete() {
        this.showPdfViewerPanel = false;
        this.pdfUrl = "";
        this.pdfName = "";
        this.deletePdfEvent.emit(this.pdfExpenseReceiptId);
    }

    async downloadReceipt() {
        if (!this.pdfUrl) {
            return;
        }
        try {
            // Fetch the PDF as a blob and trigger a download via a temporary anchor.
            // This downloads the file in-place without opening a new browser tab.
            const response = await fetch(this.pdfUrl);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            this.triggerDownload(blobUrl);
            window.URL.revokeObjectURL(blobUrl);
        } catch {
            // Fallback: download directly from the URL (still without opening a new tab).
            this.triggerDownload(this.pdfUrl);
        }
    }

    private triggerDownload(url: string) {
        const link = document.createElement("a");
        link.href = url;
        link.download = this.getDownloadFileName();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    private getDownloadFileName(): string {
        let fileName = (this.pdfName || "receipt").trim();
        if (!fileName.toLowerCase().endsWith(".pdf")) {
            fileName += ".pdf";
        }
        return fileName;
    }
} 
